import React from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { Button, GenderSelector, TitleSubtitle } from "../..";
import { ButtonContainer, ButtonIcon, ButtonLabel, CTABackAndForthContainer } from "../../../pages/Register/Register.styles";
import { GenderContainer } from "./Gender.styles";
import { useRegisterContext } from "../../../contexts/RegisterContext";

interface GenderProps extends WithRouterProps {
    onNextButtonClick: Function;
    onPrevButtonClick: Function;
}

const Gender: React.FC<GenderProps> = ({
    onNextButtonClick,
    onPrevButtonClick
}) => {
    const { registerInfo, setRegisterInfo } = useRegisterContext();

    const setGender = (gender: string) => {
        setRegisterInfo(prev => ({
            ...prev,
            user: { ...prev.user, gender }
        }));
    };

    const isNextButtonDisabled = !registerInfo.user.gender;

    return (
        <GenderContainer>
            <TitleSubtitle
                size="sm"
                title="Your Gender?"
                subTitle="So we can address you correctly in any communications."
            />
            <GenderSelector
                value={registerInfo.user.gender}
                onChange={setGender}
            />
            <CTABackAndForthContainer>
                <Button
                    size="md"
                    variant="tertiary"
                    onClick={() => onPrevButtonClick()}
                    data-cy="button-booking-next"
                    sx={{ padding: 0 }}
                >
                    <ButtonContainer>
                        <ButtonIcon icon="ArrowLeft" />
                        <ButtonLabel>Back</ButtonLabel>
                    </ButtonContainer>
                </Button>
                <Button
                    data-cy="register-gender-submit"
                    onClick={() => onNextButtonClick()}
                    disabled={isNextButtonDisabled}
                > Continue </Button>
            </CTABackAndForthContainer>
        </GenderContainer>
    );
};

Gender.displayName = "Gender";

const ComponentWithRouter = withRouter(Gender);

export { ComponentWithRouter as Gender };
